import {
  Dokument,
  DokumentApiFactory,
} from '@codefluegel/wowis-rest-typescript-client';

const uploadDocument = async (
  document: File,
  documentApi: ReturnType<typeof DokumentApiFactory>,
): Promise<Dokument> => {
  const { data: documentReply } = await documentApi.uploadDokument(
    document,
    document.name,
  );

  return {
    ...documentReply,
  };
};

export default uploadDocument;
